import type { SVGProps } from 'react';

export const EnvelopeIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M12.1597 11.7692C12.061 11.8252 11.9383 11.8252 11.8397 11.7692L1.47569 6.04387C1.89836 4.48654 3.31036 3.33321 4.99969 3.33321H18.9997C20.6943 3.33321 22.1103 4.49454 22.529 6.05853L12.1597 11.7692ZM12.001 13.8118C12.3877 13.8118 12.7743 13.7145 13.1263 13.5198L22.6663 8.26651V16.9998C22.6663 19.0225 21.0223 20.6665 18.9996 20.6665H4.99968C2.97702 20.6665 1.33302 19.0225 1.33302 16.9998V8.25051L10.873 13.5185C11.225 13.7145 11.6143 13.8118 12.001 13.8118Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);
